import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cssr21tg: FaireBrandEntity = {
  token: "b_cssr21tg",
  type: "brand",
  name: "Glory Haus",
  avatarUrl:
    "https://cdn.faire.com/fastly/e2ad63b3e1c0a3fcd187a1b1e22f71ac00e6bbd1f66e77acbc748bfe0bbaeb7e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d536469176fced5eb179ed27a2fbd66b2d81b7dfce4fcb1f99753372a65d9008.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e2ad63b3e1c0a3fcd187a1b1e22f71ac00e6bbd1f66e77acbc748bfe0bbaeb7e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d536469176fced5eb179ed27a2fbd66b2d81b7dfce4fcb1f99753372a65d9008.jpeg",
  location: "Marietta, GA, USA",
  minimumOrderDollars: 274,
  rating: 4.9,
  reviewCount: 632,
  isTopShop: true,
  isInsider: true,
  description:
    'During the 2008 economic downturn, four friends with creative hearts came together with a common passion to create Glory Haus. \n \nAs a national designer and manufacturer of inspirational gifts and home decor, we love to inspire and encourage others through our products. Our hope is that our products would be more than just beautiful art that hangs on your wall - that it would provide encouragement and bring JOY into your home. The Glory Haus mission rings true in all we do: "Community transformation that glorifies the Lord and changes lives through our work, art and relationships." \n \nToday, the Glory Haus collection includes 2,000+ products, such as ceramic ornaments, wall art, picture frames, canvases, jewelry, mugs, pillows, collegiate products, and more. Our talented artists collaborate with our design team to create the beautiful products that you see showcased on our website. \n \nAt Glory Haus, we are a family. Every member of the Glory Haus team is dedicated and passionate about our products and committed to serving our customers with the best possible customer service. Most days, you’ll find our team eating lunch together, building relationships, and sharing in special occasions. We feel incredibly blessed to get to do what we LOVE and inspire others along the way! \n',
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:02.302Z",
    importedBy: "entity-db-cli",
  },
};
